export default __webpack_public_path__ + "static/media/CimmerianSettlement.9ff5679f.jpg";